import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import qs from "query-string";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  UncontrolledAlert
} from "reactstrap";
import { resetPassword } from "../../actions/auth";
import { Helmet } from "react-helmet";
class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_confirmation: ""
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  render() {
    let { email, password, password_confirmation } = this.state;
    let { 
        resetPasswordRequest,
        resetPasswordSuccessMsg,
        resetPasswordErrorMsg,
        resetPasswordErrors
    } = this.props; 

    resetPasswordErrors = resetPasswordErrors ? resetPasswordErrors : {};
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>重置密碼 - 美南新聞</title>
        </Helmet>
        <Col lg="5" md="7">
          {resetPasswordErrorMsg && (
            <UncontrolledAlert color="danger" fade={false}>
              <span className="alert-inner--text">{resetPasswordErrorMsg}</span>
            </UncontrolledAlert>
          )}
          {resetPasswordSuccessMsg && (
            <UncontrolledAlert color="success" fade={false}>
              <span className="alert-inner--text">{resetPasswordSuccessMsg}</span>
            </UncontrolledAlert>
          )}
          <Card className=" shadow border-0">
            <CardHeader className="bg-transparent">
              <h1 className="d-flex justify-content-center align-items-center">
                重置密碼
              </h1>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-2">
              <Form onSubmit={this.onSubmit}>
                <FormGroup className="mb-3">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-email-83" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="email"
                      name="email"
                      id="loginEmail"
                      onChange={this.onInputChange}
                      value={email}
                      invalid={!!resetPasswordErrors.email}
                      placeholder="郵箱"
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    onChange={this.onInputChange}
                    value={password}
                    invalid={!!resetPasswordErrors.password}
                    placeholder="新密碼"
                  />
                  </InputGroup>
                </FormGroup>
                <FormGroup className="mb-3">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                  <Input
                    type="password"
                    name="password_confirmation"
                    id="password_confirmation"
                    onChange={this.onInputChange}
                    value={password_confirmation}
                    invalid={!!resetPasswordErrors.password_confirmation}
                    placeholder="確認新密碼"
                  />
                  </InputGroup>
                </FormGroup>
                <div className="text-center">
                  <Button
                    className="my-4 col-12"
                    color="danger"
                    type="submit"
                    disabled={resetPasswordRequest}
                  >
                    重置密碼
                  </Button>
                </div>
              </Form>
              <Row className="my-3">
                <Col className="text-center" xs="12">
                  <Link className="text-dark" to="login">
                    <small>返回登陸頁面</small>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }

  onInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onSubmit(e) {
    e.preventDefault();
    let { token } = this.props.match.params;
    let { email, password, password_confirmation } = this.state;
    this.props.resetPassword({ email, password, password_confirmation, token});
  }
}

const mapStateToProps = state => {
    let {
        resetPasswordRequest,
        resetPasswordSuccessMsg,
        resetPasswordErrorMsg,
        resetPasswordErrors} 
    = state.auth;
  return {
    resetPasswordRequest,
    resetPasswordSuccessMsg,
    resetPasswordErrorMsg,
    resetPasswordErrors
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetPassword: (email) => dispatch(resetPassword(email))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
